module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Right Arm Sofa_Cloud.d6e7e578.png";